import { SvgIcon } from '@mui/material';
import { ClipboardListSolid, CommentsSolid, FlagSolid, FileAltSolid, PenSolid } from '@assets/svgs';
import { QuoteRating, quoteRatingStatus } from '@models/quoteRating';
import { Note } from '@models/note';
import { QuoteStatusChangeItem } from '@models/quoteStatusChange';
import { Document } from '@models/document';
import { QuoteType } from '@models/quotes';
import { UnderwritingActivityItem } from '@models/underwritingReferral';

export enum QuoteActivityItemType {
  QuoteStatusChange = 'quoteStatusChange',
  QuoteRating = 'quoteRating',
  Note = 'note',
  Message = 'message',
  Document = 'document',
  UnderwritingActivity = 'underwritingActivity',
}

export type NewQuoteRatingItem = QuoteRating & {
  activityItemType: QuoteActivityItemType;
};
export type NewNoteItem = Note & {
  activityItemType: QuoteActivityItemType;
};
export type NewQuoteStatusChangeItem = QuoteStatusChangeItem & {
  activityItemType: QuoteActivityItemType;
};

export type NewDocumentItem = Document & {
  activityItemType: QuoteActivityItemType;
};

export type NewUnderwritingActivityItem = UnderwritingActivityItem & {
  activityItemType: QuoteActivityItemType;
};

export interface IQuoteActivityItem {
  item: NewQuoteRatingItem | NewNoteItem | NewQuoteStatusChangeItem | NewDocumentItem | NewUnderwritingActivityItem;
  onSelectItem: (itemId: string) => void;
  isLast: boolean;
  highlightedItem?: string | null;
  quoteType: QuoteType;
  policyNumber?: string;
}

export const activityItemTypeIcon = {
  [QuoteActivityItemType.QuoteStatusChange]: (
    <SvgIcon fontSize='small' sx={{ color: 'accent.secondary', mt: '2px', height: '16px' }}>
      <FlagSolid />
    </SvgIcon>
  ),
  [QuoteActivityItemType.QuoteRating]: (
    <SvgIcon fontSize='small' sx={{ color: 'accent.secondary', mt: '2px', height: '16px' }}>
      <FlagSolid />
    </SvgIcon>
  ),
  [QuoteActivityItemType.Note]: (
    <SvgIcon fontSize='small' sx={{ color: 'info.dark', height: '20px' }}>
      <ClipboardListSolid />
    </SvgIcon>
  ),
  [QuoteActivityItemType.Message]: (
    <SvgIcon fontSize='small' sx={{ color: 'secondary.dark', height: '24px' }}>
      <CommentsSolid />
    </SvgIcon>
  ),
  [QuoteActivityItemType.Document]: (
    <SvgIcon fontSize='small' sx={{ color: 'primary.dark', height: '20px' }}>
      <FileAltSolid />
    </SvgIcon>
  ),
  [QuoteActivityItemType.UnderwritingActivity]: (
    <SvgIcon fontSize='small' sx={{ color: 'secondary.main', height: '20px' }}>
      <PenSolid />
    </SvgIcon>
  ),
};

export const activityItemTypeText = {
  [QuoteActivityItemType.QuoteStatusChange]: 'Milestone',
  [QuoteActivityItemType.QuoteRating]: 'Milestone',
  [QuoteActivityItemType.Note]: 'Note',
  [QuoteActivityItemType.Message]: 'Message',
  [QuoteActivityItemType.Document]: 'Document',
  [QuoteActivityItemType.UnderwritingActivity]: 'Underwriting Activity',
};

export const statusText = 'Status Updated:';
export const ratingText = {
  [quoteRatingStatus.Succeeded]: (termPremium: any, termTaxFeeSurcharge?: any) =>
    `Quote rating succeeded with estimated premium of $${termPremium}${termTaxFeeSurcharge ? ` and taxes, fees, and surcharges of $${termTaxFeeSurcharge}` : ''}`,
  [quoteRatingStatus.Failed]: (errorMessage: any) => `Quote rating failed with error: ${errorMessage}`,
};
